import apiAthleteScholarships from '@/api/athlete-scholarship'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteAthleteScholarshipStart:
    '[delete athlete scholarship] Delete athlete scholarship start',
  deleteAthleteScholarshipSuccess:
    '[delete athlete scholarship] Delete athlete scholarship success',
  deleteAthleteScholarshipFailure:
    '[delete athlete scholarship] Delete athlete scholarship failure'
}

export const actionTypes = {
  deleteAthleteScholarship:
    '[delete athlete scholarship] Delete athlete scholarship'
}

const mutations = {
  [mutationTypes.deleteAthleteScholarshipStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteAthleteScholarshipSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteAthleteScholarshipFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteAthleteScholarship](context, {id}) {
    context.commit(mutationTypes.deleteAthleteScholarshipStart)
    return new Promise(resolve => {
      apiAthleteScholarships
        .deleteAthleteScholarship(id)
        .then(response => {
          context.commit(mutationTypes.deleteAthleteScholarshipSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteAthleteScholarshipFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
